module.exports = __webpack_public_path__ + "assets/img/logo.f7f16302.png";